var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 410,
    viewBox: "0 0 489 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137 144H425M137 256H425M137 368H425",
    stroke: "currentColor",
    strokeWidth: 48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 160C65.8366 160 73 152.837 73 144C73 135.163 65.8366 128 57 128C48.1634 128 41 135.163 41 144C41 152.837 48.1634 160 57 160Z",
    stroke: "currentColor",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 272C65.8366 272 73 264.837 73 256C73 247.163 65.8366 240 57 240C48.1634 240 41 247.163 41 256C41 264.837 48.1634 272 57 272Z",
    stroke: "currentColor",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 384C65.8366 384 73 376.837 73 368C73 359.163 65.8366 352 57 352C48.1634 352 41 359.163 41 368C41 376.837 48.1634 384 57 384Z",
    stroke: "currentColor",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/_list.3abb7161aef8a825c7f8601680014a5d.svg";
export { ForwardRef as ReactComponent };